import ContactForm from '@src/components/sections/educationExpertSection/ContactForm';
import React from 'react';
import { Box } from 'theme-ui';

const ContactFormBox = ({ contactFormData }: any) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateRows: ['auto', '1fr  1fr'],
        height: '100%',
        borderRadius: ['20px', '38px'],
        boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.16)',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#edf3ff',
          fontSize: ['20px', '32px'],
          lineHeight: ['26px', '44px'],
          borderRadius: ['20px 20px 0 0', '38px 38px 0 0'],
          display: 'flex',
          flexDirection: ['column', 'row'],
          padding: ['16px 30px', '50px 65px 34px 65px'],
          alignItems: 'center',
          justifyContent: ['center', 'start'],
          gap: ['10px', '90px'],
        }}
      >
        <Box
          sx={{
            width: ['44px', '57px'],
            height: ['42px', '55px'],
            margin: ['auto', '0'],
          }}
        >
          <img
            alt=""
            src={contactFormData?.icon.file.url}
            height="100%"
            width="100%"
          />
        </Box>
        <Box sx={{ textAlign: 'center', maxWidth: ['500px', '798px'] }}>
          {' '}
          {contactFormData?.title}
        </Box>
      </Box>

      <ContactForm />
    </Box>
  );
};

export default ContactFormBox;
